import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import API_BASE from "../config/api";
import { auth } from "../config/config-firebase";
import { onAuthStateChanged } from "firebase/auth";
import { resolveDefaultStoreCustomerId } from "../hooks/useMerchantStores";

const DeviceLogin = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [verified, setVerified] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    // Read device_id from URL
    const qrDeviceId = searchParams.get("device_id");

    // Retries once on failure instead of silently bouncing to /login and
    // losing the device_id (the QR code would otherwise have to be rescanned).
    const verifyDevice = async (deviceId, customerId, attempt = 1) => {
        try {

            const response = await axios.post(

                `${API_BASE}/device_login`,
                {
                    customer_id: customerId,
                    device_id :deviceId
                }
            );

            console.log("Device Login Response:", response.data);

            if (response.status === 200) {
                 navigate("/modes", {
                    state: { verifiedMsg: "Device verified successfully!" }
                });
                // setVerified(true);
            }
        } catch (error) {
            console.error(`Device login error (attempt ${attempt}):`, error);
            if (attempt < 2) {
                setTimeout(() => verifyDevice(deviceId, customerId, attempt + 1), 1500);
                return;
            }
            setErrorMsg("Couldn't verify this device. Please rescan the QR code or try again.");
        }
    };

   useEffect(() => {
        // 1️⃣ Invalid QR
        if (!qrDeviceId) {
            navigate("/login");
            return;
        }

        // 2️⃣ Wait for Firebase to resolve the current session (auth.currentUser
        // can still be null right after mount even for an already-logged-in
        // merchant), then resolve the DEFAULT store's customer_id the same way
        // Home.js does — not just "a" store, since merchantDetails/:uid alone
        // returns an arbitrary store row for multi-store accounts.
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (!currentUser) {
                // Not logged in yet — stash the device id, Home.js picks it
                // up and calls device_login once login completes.
                localStorage.setItem("pending_device_id", qrDeviceId);
                navigate("/login");
                return;
            }

            const storeCustomerId = await resolveDefaultStoreCustomerId(currentUser.uid);

            if (!storeCustomerId) {
                console.error("No store customer_id found for device login");
                setErrorMsg("We couldn't find a store linked to your account. Please contact support.");
                return;
            }

            // 3️⃣ Send device id + store customer id
            await verifyDevice(qrDeviceId, storeCustomerId);
        });

        return () => unsubscribe();

    }, [qrDeviceId, navigate]);
      return (
        <div>
            <h2>{errorMsg ? "Device verification failed" : "Verifying Device..."}</h2>
            {errorMsg && <p>{errorMsg}</p>}
        </div>
    );

    // return (
    //     <div>
    //         {verified ? (
    //             <h2>Device Verified Successfully!</h2>
    //         ) : (
    //             <h2>Verifying Device...</h2>
    //         )}
    //     </div>
    // );
};

export default DeviceLogin;
